<template>
  <div class="password-recovery-support text-center">
    <p>กรุณาติดต่อฝ่ายบริการเพื่อยืนยันตัวตนและตั้งรหัสผ่านใหม่ อย่าส่งรหัสผ่านเดิมหรือรหัส OTP ให้ผู้อื่น</p>
    <a v-if="supportLink" :href="supportLink" target="_blank" rel="noopener noreferrer" class="btn btn-primary mt-3">ติดต่อฝ่ายบริการลูกค้า</a>
    <p v-else role="status">ไม่พบช่องทางติดต่อ กรุณาใช้ช่องทางทางการของเว็บไซต์</p>
  </div>
</template>

<script>
export default {
  props: { supportUrl: { type: String, default: '' } },
  computed: {
    supportLink () {
      try {
        const url = new URL(this.supportUrl)
        return url.protocol === 'https:' ? url.href : ''
      } catch (_) { return '' }
    }
  }
}
</script>
